import {query} from 'api';
import PropType from 'prop-types';
import ConseilItem from './ConseilItem';
import {lifecycle} from 'recompose';

const ConseilsPage = ({data}) => {
  if (!data) return null;
  return data.map(conseilData => (
    <ConseilItem
      key={conseilData.id}
      title={conseilData.title.rendered}
      content={conseilData.content.rendered}
      image={conseilData.acf.conseils_image}
      link={conseilData.link}
    />
  ));
};
ConseilsPage.propTypes = {
  data: PropType.array.isRequired,
};

export default ConseilsPage
  |> lifecycle({
    componentDidMount() {
      const {data, onEndReached} = this.props;
      if (data.length === 0) {
        onEndReached();
      }
    },
  })
  |> query('getConseilsByPage', {loadingFullWidth: true}, ({page}) => `/${page}`);
